import { InlineText2 as Text } from '@cian/ui-kit';
// Оставляем как есть, нет иконки 8px
import { ArrowR8 as ArrowRightIcon } from '@cian/ui-kit/prev';

import { FC, Fragment } from 'react';

import { Layout } from '../UI/Layout';

import { IBreadCrumbsProps } from './types';

import * as styles from './styles.css';

export const BreadCrumbs: FC<IBreadCrumbsProps> = props => {
  const { breadCrumbs } = props;

  if (!breadCrumbs.length) {
    return null;
  }

  return (
    <Layout filled={false}>
      <div aria-label="Ссылки на поиск по коворкингам" className={styles['container']}>
        {breadCrumbs.map((crumb, index) => {
          const url = crumb.url || '/';
          const title = crumb.text || 'Ссылка';

          return (
            <Fragment key={`${title}`}>
              {index === 0 ? null : (
                <span className={styles['arrow']}>
                  <ArrowRightIcon />
                </span>
              )}
              <a className={styles['crumb']} href={url} title={title}>
                <Text color="gray60_100">{title}</Text>
              </a>
            </Fragment>
          );
        })}
      </div>
    </Layout>
  );
};

BreadCrumbs.displayName = 'BreadCrumbs';
